import { ProfileSurveyOverview } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';

export interface SurveySetupProps {
    profileId: number;
}

export const SurveySetup: React.FC<SurveySetupProps> = ({ profileId }) => {
    return <ProfileSurveyOverview profileId={profileId} />;
};
